import { SocialPlatform, type AppConfig } from "@iyk/vf-app-config"
import { Duration } from "effect"

export const appConfig: AppConfig<"the-hives"> = {
  appId: "the-hives",
  cookiePrefix: "th",
  lang: "EN",
  artist: {
    name: "The Hives"
  },
  meta: {
    description: "The Hives"
  },
  emailSender: {
    name: "The Hives",
    email: "thehives@iyk.app"
  },
  s3: {
    get assets() {
      const baseUrl = "https://assets.iyk.app"
      return {
        baseUrl,
        vfUrl: `${baseUrl}/vf`,
        appUrl: `${baseUrl}/${appConfig.appId}`
      }
    },
    get files() {
      return {
        exclusives: `${appConfig.appId}/exclusives`,
        fanClips: `${appConfig.appId}/fan-clips`,
        merchSkus: `${appConfig.appId}/merch-skus`,
        playlistCoverImages: `${appConfig.appId}/playlist-cover-images`,
        showImages: `${appConfig.appId}/show-images`,
        showCheckInRequestImages: `${appConfig.appId}/check-in-request-images`
      }
    },
    get music() {
      return {
        trackAudios: `${appConfig.appId}/track-audios`,
        playlistDownloadFiles: `${appConfig.appId}/playlist-download-files`
      }
    }
  },
  merch: {
    initialOwnerId: "00000000-0000-0000-0000-000000000000",
    initialOwnerAddress: "0x3dd4c3f9bc97cd9d90a57ee847f3a27fc74e2038"
  },
  tasks: {
    exclusiveLinkDelay: Duration.hours(1)
  },
  checkIn: {
    hidePrompt: true
  },
  shopUrl: null,
  socialLinks: [
    {
      platform: SocialPlatform.Facebook,
      label: "Facebook",
      href: "https://www.facebook.com/hives"
    },
    {
      platform: SocialPlatform.Instagram,
      label: "Instagram",
      href: "https://instagram.com/thehives"
    },
    {
      platform: SocialPlatform.TikTok,
      label: "TikTok",
      href: "https://tiktok.com/@the.hives"
    },
    {
      platform: SocialPlatform.Spotify,
      label: "Spotify",
      href: "https://open.spotify.com/artist/4DToQR3aKrHQSSRzSz8Nzt?si=-xegA23iRp6LxjOS-rNoCQ"
    },
    {
      platform: SocialPlatform.Youtube,
      label: "YouTube",
      href: "https://www.youtube.com/channel/UC_aDZ5VN3pMmJ0BdxFpO4oQ"
    },
    {
      platform: SocialPlatform.Twitter,
      label: "X",
      href: "https://x.com/thehives"
    }
  ],
  joinProof: null,
  get assets() {
    return {
      images: {
        avatar: `${appConfig.s3.assets.appUrl}/avatar.webp`,
        og: `${appConfig.s3.assets.appUrl}/og.png`,
        logo: {
          url: `${appConfig.s3.assets.appUrl}/logo.png`,
          width: 96
        },
        email: {
          logo: {
            url: `${appConfig.s3.assets.appUrl}/email-logo.png`,
            width: 96
          }
        },
        background: `${appConfig.s3.assets.appUrl}/background.webp`,
        howToTap: null,
        roulette: {
          images: Array.from({ length: 6 }, (_, i) => `${appConfig.s3.assets.vfUrl}/roulette/${i + 1}.webp`)
        },
        enableLocation: {
          ios: {
            step1: `${appConfig.s3.assets.vfUrl}/check-in/enable_location_ios_1.png`,
            step2: `${appConfig.s3.assets.vfUrl}/check-in/enable_location_ios_2.png`
          },
          android: {
            step1: `${appConfig.s3.assets.vfUrl}/check-in/enable_location_android.png`
          }
        }
      },
      videos: {
        marquee: null,
        howToTap: null
      },
      documents: {
        privacyPolicy: `${appConfig.s3.assets.baseUrl}/iyk-privacy-policy.pdf`,
        termsOfService: `${appConfig.s3.assets.baseUrl}/iyk-terms-of-service.pdf`,
        artistPrivacyPolicy: null,
        artistTermsOfService: null,
        sweepstakeRules: null
      }
    }
  }
}
